export enum LoaiMediaEnum {
  IMAGE = 'Hình ảnh',

  VIDEO = 'Video',
}
